import { Component, inject, Input, OnInit } from '@angular/core';
import { LoadpointModel, LoadpointService } from '@railmybox/api-booking';
import { FormControl } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { switchMap } from 'rxjs/operators';
import { AbstractValueAccessorComponent, ValueAccessorUtil } from '@railmybox/shared/util';

@UntilDestroy()
@Component({
  selector: 'rmb-container-terminal-select',
  templateUrl: './container-terminal-select.component.html',
  styleUrls: ['./container-terminal-select.component.scss'],
  providers: [...ValueAccessorUtil.getValueAccessorProvider(ContainerTerminalSelectComponent)],
  standalone: false,
})
export class ContainerTerminalSelectComponent extends AbstractValueAccessorComponent<string> implements OnInit {
  private loadPointService = inject(LoadpointService);

  containerTerminals$: Observable<LoadpointModel[]>;
  searchControl: FormControl = new FormControl(undefined);
  selectedName: string;
  @Input() clearable = false;

  ngOnInit(): void {
    this.containerTerminals$ = this.searchControl.valueChanges.pipe(
      untilDestroyed(this),
      switchMap((query: string) => (query ? this.loadPointService.listLoadpoints({ query }) : of([])))
    );
  }

  onSearchValueChanged(query: string): void {
    this.searchControl.patchValue(query);
  }

  onSelect(terminal: LoadpointModel): void {
    this.selectedName = terminal?.name;
    this.value = terminal?.id;
    this.onChange(terminal?.id);
    this.changed.emit(terminal?.id);
  }

  async writeValue(value: string): Promise<void> {
    super.writeValue(value);

    const loadPoints = await this.loadPointService.listLoadpoints().toPromise();
    const selectedLoadPoint = loadPoints.find((point) => point.id === value);

    if (!selectedLoadPoint) {
      return;
    }
    this.selectedName = selectedLoadPoint.name;
  }
}
